import * as React from "react";
import { PropsWithChildren } from "react";

interface BodyProps {}

export function Body(props: PropsWithChildren<BodyProps>) {
  return <>{props.children}</>;
}
